"use client";

import useTranslate from "@app/_hooks/useTranslate";
import { useMarket } from "@features/market/useMarket";
import Link from "next/link";

export const NewCustomerHeader = ({ onClose }: { onClose?: () => void }) => {
  const t = useTranslate();
  const { siteLocale: locale } = useMarket();
  return (
    <div className="flex max-w-72 flex-col">
      <h2 className="text-lg">{t("newCustomerFormHeading")}</h2>

      <p className="mt-3 mb-6 flex-1 text-base">
        {t("newCustomerFormInfoText")}
      </p>
      <p className="text-sm">
        {" "}
        {t("newCustomerFormTermsText")}{" "}
        <Link
          locale={locale}
          className="underline"
          onClick={onClose}
          href={t("newCustomerFormTermsLink")}
        >
          {t("newCustomerFormTermsLinkText")}
        </Link>
      </p>
    </div>
  );
};
